import { Link } from "react-router-dom";
import { MapPin, Package, HelpCircle } from "lucide-react";

export const LocationSummary = ({ locations, unassigned = 0, onUnassigned }) => (
  <div data-testid="location-summary">
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E665D] mb-4">Bottles by location · open one, or use Search above</p>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {locations.map((l, i) => (
        <Link key={l.id} to={`/locations/${l.id}`} data-testid={`summary-location-${l.id}`} style={{ animationDelay: `${i * 30}ms` }}
          className="rise group rounded-xl border border-[#2E252A] bg-[#161214] p-4 hover:border-[#D4AF37] hover:-translate-y-0.5 transition-[border-color,transform] duration-200">
          <p className="flex items-center gap-2 text-sm text-[#F5F0EB] truncate"><MapPin className="w-3.5 h-3.5 shrink-0 text-[#D4AF37]" />{l.name}</p>
          <div className="flex items-baseline gap-4 mt-3">
            <p><span className={`text-3xl font-semibold tabular-nums ${l.bottle_count ? "text-[#F5F0EB]" : "text-[#6E665D]"}`} data-testid={`summary-bottles-${l.id}`}>{l.bottle_count}</span> <span className="text-xs text-[#6E665D]">btl</span></p>
            {!!l.box_count && <p className="text-sm text-[#A89F91]" data-testid={`summary-boxes-${l.id}`}><Package className="w-3.5 h-3.5 inline mr-1" strokeWidth={1.5} />{l.box_count}</p>}
          </div>
        </Link>
      ))}
      {!!unassigned && (
        <button onClick={onUnassigned} data-testid="summary-unassigned"
          className="rise text-left rounded-xl border border-dashed border-[#E5A93C]/60 bg-[#161214] p-4 hover:border-[#E5A93C] hover:-translate-y-0.5 transition-[border-color,transform] duration-200">
          <p className="flex items-center gap-2 text-sm text-[#E5A93C]"><HelpCircle className="w-3.5 h-3.5 shrink-0" />Unassigned</p>
          <p className="mt-3"><span className="text-3xl font-semibold tabular-nums text-[#F5F0EB]" data-testid="summary-unassigned-count">{unassigned}</span> <span className="text-xs text-[#6E665D]">btl without a location</span></p>
        </button>
      )}
      {!locations.length && !unassigned && <p className="text-[#6E665D] col-span-full py-10 text-center">No locations yet — create them in Locations.</p>}
    </div>
  </div>
);
